import { render, staticRenderFns } from "./EditJob.vue?vue&type=template&id=124ec2ad"
import script from "./EditJob.vue?vue&type=script&lang=js"
export * from "./EditJob.vue?vue&type=script&lang=js"
import style0 from "./EditJob.vue?vue&type=style&index=0&id=124ec2ad&prod&lang=scss"
import style1 from "./EditJob.vue?vue&type=style&index=1&id=124ec2ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports